import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomTrustLedgerItem } from '@models/trustLedger';
import { cloneDeep } from 'lodash';
import { TestHooks } from './payment-receipt-modal.hooks';

export interface PaymentReceiptModalData {
	item: CustomTrustLedgerItem;
}

@Component({
	selector: 'app-payment-receipt-modal',
	templateUrl: './payment-receipt-modal.component.html',
	styleUrls: ['./payment-receipt-modal.component.scss'],
	standalone: false,
})
export class PaymentReceiptModalComponent {
	testHooks = TestHooks;
	customItem: CustomTrustLedgerItem;
	submitted = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: PaymentReceiptModalData,
		public dialogRef: MatDialogRef<PaymentReceiptModalComponent>,
	) {
		this.customItem = cloneDeep(data?.item);
	}

	cancel() {
		this.dialogRef.close();
	}

	save(form: NgForm) {
		this.submitted = true;
		if (form.valid) {
			this.dialogRef.close(this.customItem);
		}
	}
}
